// AuthCallback.tsx — rota de callback OIDC.
//
// Cognito redireciona aqui após autenticação SAML com `?code=...`.
// Amplify v6 detecta o code via Hub event 'signInWithRedirect' e troca por tokens
// automaticamente. Renderizamos só um loading enquanto isso acontece, depois
// navega pra Home (ou pra `from` se veio de uma protected route).

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';

import { Container } from '@/components/ui/Container';
import { useSession } from '@/lib/auth/useSession';

export function AuthCallback() {
  const navigate = useNavigate();
  const { status } = useSession();

  useEffect(() => {
    // Quando já autenticado, redireciona pra home
    if (status === 'authenticated') {
      navigate('/', { replace: true });
      return;
    }

    // Escuta Hub event de signInWithRedirect concluído
    const unsub = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect') {
        navigate('/', { replace: true });
      } else if (payload.event === 'signInWithRedirect_failure') {
        console.error('[AuthCallback] SAML signin failed', payload.data);
        navigate('/login?error=saml_failure', { replace: true });
      }
    });

    return unsub;
  }, [status, navigate]);

  return (
    <main className="grid min-h-dvh place-items-center bg-canvas px-6 py-12">
      <Container size="sm">
        <div className="flex flex-col items-center gap-3 text-center">
          <div
            aria-hidden="true"
            className="h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent"
          />
          <p className="text-sm text-muted">Autenticando…</p>
        </div>
      </Container>
    </main>
  );
}
